module.exports = {
    devServer: {
        public: 'miapptsil.miatsil.org.mx/',
        host: '0.0.0.0',
        port:8086,
        disableHostCheck: true,
        hot: false,
        liveReload: false,
        //webSocketServer: false,
        headers: {
            'Access-Control-Allow-Origin': '*'
        },
        //useLocalIp:false,
        proxy: {
            '/apidev': {
                target: 'http://localhost:3006/',
                pathRewrite: {'^/apidev' : ''}
            },
            '/resources': {
                target: 'http://localhost:3006/',
                pathRewrite: {'^/resources' : ''}
            }  
        }
    }
}

